<template>
    <Card class="chart-filters">
        <div class="columns">
            <div class="column is-2">
                <b-field :label="$t('admin.efficiency.chart.chartFilters.labels.line')">
                    <Select
                        :seed="chartFilters"
                        :value="chartFilters.line"
                        class="white"
                        :get-data="() => getParameters(chartFilters.bar)"
                        :placeholder="$t('admin.efficiency.chart.chartFilters.labels.parameter')"
                        @input="changeFilters($event, 'line')">
                    </Select>
                </b-field>
            </div>
            <div class="column is-2">
                <b-field :label="$t('admin.efficiency.chart.chartFilters.labels.bar')">
                    <Select
                        :seed="chartFilters"
                        :value="chartFilters.bar"
                        class="white"
                        :get-data="() => getParameters(chartFilters.line)"
                        :placeholder="$t('admin.efficiency.chart.chartFilters.labels.parameter')"
                        @input="changeFilters($event, 'bar')">
                    </Select>
                </b-field>
            </div>
        </div>
    </Card>
</template>

<script>
  import { UPDATE_EFFICIENCY_CHART_FILTERS, GET_EFFICIENCY_GRAPH } from "@core/store/action-constants";
  import Select from "@/components/Common/Select/Select.vue";
  import Card from "@/components/Common/Card";
  import { mapActions, mapState } from "vuex";
  import _cloneDeep from "lodash/cloneDeep";
  import _debounce from "lodash/debounce";

  export default {
    name: "EfficiencyChartFilters",
    components: { Select, Card },

    created () {
      const {
        line,
        bar
      } = this.$route.query;

      this.UPDATE_EFFICIENCY_CHART_FILTERS({ line: line ?? "countLeadsValid", bar: bar ?? "countActiveWebmasters" });
      this.GET_EFFICIENCY_GRAPH();
    },

    data () {
      return {
        parameters: [
          {
            name: this.$t("admin.efficiency.chart.chartFilters.values.plan"),
            id: "plan"
          },
          {
            name: this.$t("admin.efficiency.chart.chartFilters.values.percentPlan"),
            id: "percentPlan"
          },
          {
            name: this.$t("admin.efficiency.chart.chartFilters.values.countLeadsValid"),
            id: "countLeadsValid"
          },
          {
            name: this.$t("admin.efficiency.chart.chartFilters.values.countLeadsAccepted"),
            id: "countLeadsAccepted"
          },
          {
            name: this.$t("admin.efficiency.chart.chartFilters.values.percentLeadsAccepted"),
            id: "percentLeadsAccepted"
          },
          {
            name: this.$t("admin.efficiency.chart.chartFilters.values.cashFlow"),
            id: "cashFlow"
          },
          {
            name: this.$t("admin.efficiency.chart.chartFilters.values.countWebmasters"),
            id: "countWebmasters"
          },
          {
            name: this.$t("admin.efficiency.chart.chartFilters.values.countActiveWebmasters"),
            id: "countActiveWebmasters"
          },
          {
            name: this.$t("admin.efficiency.chart.chartFilters.values.sumCommission"),
            id: "sumCommission"
          },
          {
            name: this.$t("admin.efficiency.chart.chartFilters.values.averageCommission"),
            id: "averageCommission"
          }
        ]
      };
    },

    computed: {
      ...mapState("admin/efficiency", {
        chartFilters: (state) => state.chartFilters
      }),

      debouncedUpdate () {
        return _debounce(this.debouncedRequest, 400, { leading: true, trailing: true });
      }
    },
    methods: {
      ...mapActions("admin/efficiency", [
        UPDATE_EFFICIENCY_CHART_FILTERS,
        GET_EFFICIENCY_GRAPH
      ]),

      getParameters (exclude) {
        return {
          items: this.parameters.filter(({ id }) => id !== exclude)
        };
      },

      debouncedRequest () {
        const query = { ...this.$route.query };

        query.line = this.chartFilters.line;
        query.bar = this.chartFilters.bar;

        this.$router.push({
          query
        }).catch(_ => {});
      },

      changeFilters (value, key) {
        const filters = _cloneDeep(this.chartFilters);
        filters[key] = value;
        this.UPDATE_EFFICIENCY_CHART_FILTERS(filters);
        this.GET_EFFICIENCY_GRAPH();
      }
    },
    watch: {
      chartFilters: {
        deep: true,
        handler () {
          this.debouncedUpdate();
        }
      }
    }
  };
</script>

<style scoped>
</style>
